export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_CRITERE_REMISE_BANCAIRE = 'SET_CRITERE_REMISE_BANCAIRE';
export const SET_CRITERE_LOT_PAIEMENT = 'SET_CRITERE_LOT_PAIEMENT';
